import { FC, memo } from 'react';
import { Counter } from '@app/shared';
import { getPriceFormat } from '@app/shared/helpers';
import { useEvent } from '@hooks/useEvent';
import { ProductTypeProps } from './TypeProps';
import { useCounter } from '@hooks/useCounter';
import ClassNames from 'classnames';
import { ServiceEcommerce2 } from '@app/services/ServiceEcommerce';

import styles from './ProductPrice.module.scss';

export const ProductPrice: FC<ProductTypeProps> = memo(function ProductPrice(props) {
  const { productId, part, price, specPrice, quantity = 1, allQuantity = 1, className, handlerUpdateQuantity } = props;

  const { count, increment, decrement } = useCounter(quantity);
  const handleIncrement = useEvent(async () => {
    if (count + 1 <= allQuantity) {
      ServiceEcommerce2.addToCart([
        {
          part,
          id: productId,
          quantity: 1,
        },
      ]);

      await handlerUpdateQuantity(count + 1);
      increment();
    }
  });
  const handleDecrement = useEvent(async () => {
    if (count - 1 > 0) {
      ServiceEcommerce2.removeFromCart([
        {
          part,
          id: productId,
          quantity: 1,
        },
      ]);
      await decrement();
      await handlerUpdateQuantity(count - 1);
    }
  });
  return (
    <div className={ClassNames(styles.Wrapper, className)}>
      {price !== 0 || allQuantity !== 0 ? (
        <>
          {' '}
          <div className={styles.ContainerOne}>
            <Counter
              allQuantity={allQuantity}
              part={part}
              count={count}
              handleIncrement={handleIncrement}
              handleDecrement={handleDecrement}
              max={allQuantity}
              min={1}
            />
            <div className={styles.Price}>{getPriceFormat(specPrice)} ₽ / шт.</div>
          </div>
          <div className={styles.ContainerTwo}>
            <div className={styles.AllPrice}>{getPriceFormat(count * specPrice)} ₽</div>
            {price !== specPrice && <del className={styles.AllDiscount}>{getPriceFormat(count * price)} ₽</del>}
          </div>
        </>
      ) : (
        <span>Нет в наличии</span>
      )}

      <div className={styles.Quantity}>
        {count}
        <div className={styles.Price}>{getPriceFormat(specPrice)} ₽ / шт.</div>
      </div>
    </div>
  );
});
